import { createContext, useContext, useEffect, useState } from "react";
import { T } from "@/data/content";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("y5_lang") || "en");

  useEffect(() => {
    localStorage.setItem("y5_lang", lang);
    document.documentElement.setAttribute("lang", lang);
  }, [lang]);

  const toggle = () => setLang((l) => (l === "en" ? "fr" : "en"));

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle, t: T[lang] }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLanguage = () => useContext(LanguageContext);
